import React from 'react'
import {RsvpInfoButton} from '../rsvp-info-button'
import {DH} from '../../../constants/data-hooks'
import {TicketsUnavailableButtonProps} from '.'

export const TicketsUnavailableButton: React.FC<TicketsUnavailableButtonProps> = ({
  ticketsUnavailableMessages,
  onClick,
}) => <RsvpInfoButton messages={ticketsUnavailableMessages} dataHook={DH.TICKETS_UNAVAILABLE} onClick={onClick} />
